import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    children: [
		    { 
            path: '', 
            redirectTo: 'signon', 
            pathMatch: 'full' 
        },
        /*
            NEXUS-STARTER NOTE:
            Use loadChildren option to specify routes for lazy loaded modules. Use loadChildren in order to tell webpack to separate the module into a new javascript chunk file.
            Example:
            {
                path: '{path}',
		            loadChildren: '{path/to/module}#{subAppName}Module'
            }            
        */
        {
          path: 'signon',
         // loadChildren: './signon/signon.module#SignonModule'
          loadChildren: () => import('./signon/signon.module').then(m => m.SignonModule)
        },
        {
          path: 'ssologin',
          loadChildren: () => import('./ssologin/ssologin.module').then(m => m.SsologinModule)
        },
        {
          path: 'ssoauthenticate',
          loadChildren: () => import('./signon/signon.module').then(m => m.SignonModule)
        } ,
        {
          path: 'ssoauthorize',
          loadChildren: () => import('./signon/signon.module').then(m => m.SignonModule)
        } ,
        {
          path: 'tyRewardsSignon',
          loadChildren: () => import('./tyrewards/tyrewards.module').then(m => m.TyRewardsModule)
        },
        {
          path: 'browsernotsupported',
         // loadChildren: './browsernotsupported/browsernotsupported.module#BrowsernotsupportedModule'
          loadChildren: () => import('./browsernotsupported/browsernotsupported.module').then(m => m.BrowsernotsupportedModule)
        }      
        /* 
          DO NOT DELETE @NS-CLI@ DIRECTIVES. THEY ARE USED FOR NS-CLI. 
          OTHERWISE NS-CLI MAY STOP WORKING IN THE PROPER WAY. 
        */
        /*@NS-CLI-ROUTING@*/   
	]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
